<template>
    <div class="form-check form-switch form-switch-md" :class="classes">
        <input
            class="form-check-input"
            :checked="value"
            type="checkbox"
            :id="id"
            :name="name"
            @click="switched"
        />
        <label
            class="form-check-label"
            :for="id"
            >{{ label }}</label
        >
    </div> 
</template>


<script>
    export default {
        props: {
            id: String,
            label: String,
            name: String,
            value: Boolean,
            classes: String
        },

        data() {
            return {
                checkValue: this.value
            }
        },

        methods: {
            switched() {
                this.checkValue = !this.checkValue
                this.$emit('input', this.checkValue);
            }
        }
    }
</script>

